import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, AbstractControl, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ElementCreateComponent } from '../element-create/element-create.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { VisationModalComponent } from '../../../notifications/visation-modal/visation-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { MatNativeDateModule } from '@angular/material/core';

@Component({
  selector: 'app-task-create',
  templateUrl: './task-create.component.html',
  styleUrls: ['./task-create.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatExpansionModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    ElementCreateComponent,
    MatCheckboxModule,
    VisationModalComponent,
    MatDialogModule,
    MatNativeDateModule,
  ],
})
export class TaskCreateComponent implements OnInit {
  @Input() isMaintenanceUpdate: boolean = false;
  @Input() index!: number;
  @Input() formGroup!: FormGroup;
  @Input() tasks: any[] = [];
  @Input() acceptanceCriterias: any[] = [];
  @Output() removeTask = new EventEmitter<void>();

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    // this.formGroup = this.fb.group({
    //   tasks: this.fb.array([]), // Asegúrate de que este FormArray esté siempre inicializado
    //   acceptanceCriterias: this.fb.array([]) // Lo mismo para este FormArray
    // });
  }

  get elementsFormArray(): FormArray {
    return this.formGroup.get('elements') as FormArray;
  }

  addElement() {
    this.elementsFormArray.push(
      this.fb.group({
        labelName: [''],
        order: [null, Validators.required],
        required: [false],
        elementType: [''],
        visation: this.fb.group({
          id: [null], // Asegura que incluya el campo `id`
          effectiveDate: this.isMaintenanceUpdate ? ['', Validators.required] : [''],
          visationActions: this.fb.group({
            id: [null], // ID de la acción
            observation: [''],
            filePath: [''],
            originalFileName: [''],
            action: this.fb.group({
              id: [null], // ID de la acción dentro de visationActions
              name: [''], // Nombre de la acción
            }),
          }),
        }),
      }),
    );
  }

  removeElement(index: number) {
    this.elementsFormArray.removeAt(index);
  }

  getElementFormGroup(control: AbstractControl): FormGroup {
    return control as FormGroup;
  }

  getAcceptanceCriteriaFormArray(): FormArray {
    return this.formGroup.get('acceptanceCriterias') as FormArray;
  }

  addAcceptanceCriteria() {
    const criteriaFormArray = this.getAcceptanceCriteriaFormArray();
    criteriaFormArray.push(
      this.fb.group({
        acceptanceCriteriaId: [null, Validators.required],
        acceptanceCriteriaName: [''],
        order: [null, Validators.required],
        required: [false],
        elements: this.fb.array([]),
        visation: this.fb.group({
          id: [null], // Asegura que incluya el campo `id`
          effectiveDate: this.isMaintenanceUpdate ? ['', Validators.required] : [''],
          visationActions: this.fb.group({
            id: [null], // ID de la acción
            observation: [''],
            filePath: [''],
            originalFileName: [''],
            action: this.fb.group({
              id: [null], // ID de la acción dentro de visationActions
              name: [''], // Nombre de la acción
            }),
          }),
        }),
      }),
    );
  }

  removeAcceptanceCriteria(criteriaIndex: number) {
    const criteriaFormArray = this.getAcceptanceCriteriaFormArray();
    criteriaFormArray.removeAt(criteriaIndex);
  }

  getAcceptanceCriteriaElementsFormArray(criteriaIndex: number): FormArray {
    const criteriaFormArray = this.getAcceptanceCriteriaFormArray();
    const criteriaGroup = criteriaFormArray.at(criteriaIndex) as FormGroup;
    return criteriaGroup.get('elements') as FormArray;
  }

  addElementToAcceptanceCriteria(criteriaIndex: number) {
    const elementsFormArray = this.getAcceptanceCriteriaElementsFormArray(criteriaIndex);
    elementsFormArray.push(
      this.fb.group({
        labelName: ['', Validators.required],
        elementType: ['', Validators.required],
        order: [null, Validators.required],
        required: [false],
        visation: this.fb.group({
          id: [null], // Asegura que incluya el campo `id`
          effectiveDate: this.isMaintenanceUpdate ? ['', Validators.required] : [''],
          visationActions: this.fb.group({
            id: [null], // ID de la acción
            observation: [''],
            filePath: [''],
            originalFileName: [''],
            action: this.fb.group({
              id: [null], // ID de la acción dentro de visationActions
              name: [''], // Nombre de la acción
            }),
          }),
        }),
      }),
    );
  }

  removeElementFromAcceptanceCriteria(criteriaIndex: number, elementIndex: number) {
    const elementsFormArray = this.getAcceptanceCriteriaElementsFormArray(criteriaIndex);
    elementsFormArray.removeAt(elementIndex);
  }

  updateAcceptanceCriteriaName(criteriaIndex: number, acceptanceCriteriaId: number) {
    const acceptanceCriteria = this.acceptanceCriterias.find(a => a.id === acceptanceCriteriaId);
    if (acceptanceCriteria) {
      this.getAcceptanceCriteriaFormArray()
        .at(criteriaIndex)
        .get('acceptanceCriteriaName')
        ?.setValue(acceptanceCriteria.name);
    }
  }

  onRemoveTask(event: Event): void {
    event.stopPropagation(); // Detiene la propagación del evento para que no afecte al mat-expansion-panel
    this.removeTask.emit(); // Emite el evento para eliminar la tarea
  }

  // Abrir el modal para notificar cambios
  openVisationModal(context: string, criteriaIndex?: number): void {
    let visationData = {
      effectiveDate: '',
      observation: '',
      originalFileName: '',
    };
    if (context === 'task') {
      const visation = this.formGroup.get('visation')?.value;
      if (visation) {
        visationData.effectiveDate = visation.effectiveDate;
        visationData.observation = visation.visationActions?.observation || ''; // Obtener la observación si existe
        visationData.originalFileName = visation.visationActions?.originalFileName || ''; // Obtener el nombre del archivo original si existe
      }
    } else if (context === 'acceptanceCriteria' && typeof criteriaIndex === 'number') {
      const criteriaFormArray = this.getAcceptanceCriteriaFormArray();
      const visation = criteriaFormArray.at(criteriaIndex).get('visation')?.value;
      if (visation) {
        visationData.effectiveDate = visation.effectiveDate;
        visationData.observation = visation.visationActions?.observation || '';
        visationData.originalFileName = visation.visationActions?.originalFileName || '';
      }
    }

    const config = {
      title: 'Notificar Cambio',
      description: 'Completa los siguientes campos para notificar el cambio realizado.',
      cancelButtonText: 'Cancelar',
      submitButtonText: 'Enviar',
      fields: [
        {
          name: 'effectiveDate',
          label: 'Indica la fecha que iniciará este cambio',
          type: 'datepicker',
          value: visationData.effectiveDate,
          required: true,
        },
        {
          name: 'comment',
          label: 'Escribe un comentario para la notificación',
          type: 'textarea',
          value: visationData.observation,
          required: true,
        },
        {
          name: 'file',
          label: 'Adjunta documentación',
          type: 'file',
          originalFileName: visationData.originalFileName,
        },
      ],
    };

    const dialogRef = this.dialog.open(VisationModalComponent, {
      width: '400px',
      data: config,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Guardar el archivo en Base64 y su nombre original si existe
        const formData: any = {
          effectiveDate: result.effectiveDate,
          visationActions: {
            observation: result.comment || '', // Asegúrate de que el comentario esté presente
            originalFileName: result.fileName || '', // Controla que no sea undefined
            filePath: result.fileBase64 || '', // Controla que no sea undefined
          },
        };

        if (context === 'acceptanceCriteria' && typeof criteriaIndex === 'number') {
          const criteriaFormArray = this.getAcceptanceCriteriaFormArray();
          criteriaFormArray.at(criteriaIndex).patchValue({
            visation: formData,
          });
        } else if (context === 'task') {
          this.formGroup.patchValue({ visation: formData });
        }
      }
    });
  }

  private getFormGroupIndex(formArray: FormArray, control: AbstractControl): number {
    return formArray.controls.indexOf(control);
  }

  trackByFn(index: number, item: AbstractControl): number {
    return index; // O puedes usar un identificador único si lo tienes
  }
}
